module.exports = __webpack_public_path__ + "img/background.86fb4357.png";